

































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import DashboardDokterStore from "@/store/modules/DashboardDokterStore";
import { userModule } from "@/store/modules/user";
import { daftarPasienRouteName, isRanap } from "@/utils/unit";
import { SapaanWaktu, WaktuSapaan, sapaanWaktu } from "@/utils/sapaanWaktu";
import {
  DashboardDokterCard,
  DashboardDokterKartu,
  DashboardUnitAktif,
  DashboardUnitJenis
} from "@/types/daftarRegisterPasien";

const WARNA_IKON: Record<WaktuSapaan, string> = {
  pagi: "yellow darken-3",
  sore: "orange darken-3",
  malam: "indigo darken-3"
};

const LABEL_UNIT: Record<DashboardUnitJenis, string> = {
  ralan: "Pasien di Klinik Ini",
  igd: "Pasien di IGD",
  ranap: "Pasien di Bangsal Ini"
};

@Component
export default class DashboardDokter extends Vue {
  sekarang = new Date();
  timer: number | null = null;

  get loading(): boolean {
    return DashboardDokterStore.loading;
  }

  get cards() {
    return DashboardDokterStore.cards;
  }

  get sapaan(): SapaanWaktu {
    return sapaanWaktu(this.sekarang.getHours());
  }

  get warnaIkon(): string {
    return WARNA_IKON[this.sapaan.waktu];
  }

  get namaUser(): string {
    return userModule.user?.nama ?? "";
  }

  get unitNama(): string {
    return userModule.user?.unit ?? "";
  }

  get unitLabel(): string {
    const nama = this.unitNama;

    if (isRanap(userModule.user?.unit_id) && !/^ruang\b/i.test(nama)) {
      return `Ruang ${nama}`;
    }

    return nama;
  }

  get unitJudul(): string {
    return `Unit/ruang aktif: ${this.unitLabel}`;
  }

  get tanggalLabel(): string {
    return moment(this.sekarang).format("dddd, DD MMMM YYYY");
  }

  get tanggalBesokLabel(): string {
    return moment(this.sekarang)
      .add(1, "day")
      .format("DD MMM");
  }

  get daftarKartu(): DashboardDokterKartu[] {
    const cards = this.cards;

    return [
      this.kartuUnit(cards ? cards.unit_aktif : null),
      {
        key: "ranap_dirawat",
        label: "Pasien Rawat Inap",
        icon: "mdi-bed",
        color: "green darken-1",
        angka: this.angka(cards ? cards.ranap_dirawat : null),
        rincian: [],
        route: { name: "daftar-register-pasien", query: { mode: "ranap" } }
      },
      {
        key: "pasien_akan_datang",
        label: "Pasien Akan Datang",
        icon: "mdi-calendar-clock",
        color: "purple darken-1",
        angka: this.angka(cards ? cards.pasien_akan_datang : null),
        rincian: [`Besok, ${this.tanggalBesokLabel}`],
        route: { name: "daftar-pasien-akan-datang" }
      },
      {
        key: "belum_resume",
        label: "Resume Belum Dilengkapi",
        icon: "mdi-file-document-edit-outline",
        color: "orange darken-2",
        angka: this.angka(cards ? cards.belum_resume : null),
        rincian: [],
        route: {
          name: "daftar-register-pasien",
          query: { mode: "belum-resume" }
        }
      },
      {
        key: "dp_belum_ttd",
        label: "Dokumen Perlu Verifikasi",
        icon: "mdi-clipboard-check-outline",
        color: "blue darken-1",
        angka: this.angka(cards ? cards.dp_belum_ttd : null),
        rincian: [],
        route: {
          name: "daftar-register-pasien",
          query: { mode: "dp-belum-ttd" }
        }
      }
    ];
  }

  kartuUnit(unit: DashboardUnitAktif | null): DashboardDokterKartu {
    const rincian: string[] = [];

    if (unit && unit.jenis === "ralan") {
      rincian.push(`${unit.dilayani} dilayani`, `${unit.antre} antre`);
    }

    if (unit && unit.jenis === "ranap") {
      rincian.push(
        `${unit.divisite} divisite`,
        `${unit.belum_divisite} belum divisite`
      );
    }

    return {
      key: "unit_aktif",
      label:
        unit && unit.jenis ? LABEL_UNIT[unit.jenis] : "Pasien di Unit Ini",
      icon: "mdi-map-marker",
      color: "teal darken-1",
      angka: unit && unit.count !== null ? String(unit.count) : "–",
      rincian,
      route: { name: daftarPasienRouteName(userModule.user?.unit_id) }
    };
  }

  angka(card: DashboardDokterCard | null): string {
    if (!card) {
      return "–";
    }

    return card.capped ? `${card.count}+` : String(card.count);
  }

  buka(kartu: DashboardDokterKartu) {
    this.$router.push(kartu.route).catch(() => undefined);
  }

  muatUlang() {
    this.sekarang = new Date();
    DashboardDokterStore.fetch(true);
  }

  mounted() {
    DashboardDokterStore.fetch();

    this.timer = window.setInterval(() => {
      this.sekarang = new Date();
    }, 60000);
  }

  beforeDestroy() {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
    }
  }
}
